<template>
  <div class="overlay">
    <div class="iframe">
      <iframe ref="AIIFrame" class="iframeAi" :src="src" frameborder="0" @load="onIframeLoad" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Iframe",
  props: {
    aiUserInfoForm: {
      type: Object,
      default: () => {}
    },
    iframeShow: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // iframeShow: false
    };
  },
  destroyed() {
    // 销毁时移除事件监听
    window.removeEventListener("message", this.handleMessage);
  },

  methods: {
    // 处理 iframe 加载完成事件
    onIframeLoad() {
      console.log("iframe 加载完成");
      // 加载完成后发送消息
      this.sendMessageToIframe();
      // 监听 message 事件
      window.addEventListener("message", this.handleMessage);
    },
    // 处理接收到的消息
    handleMessage(event) {
      const targetOrigin = "http://aihelp-test.youjiayun.com";
      if (event.origin === targetOrigin) {
        // 处理接收到的消息
        console.log("ai项目 message:", event.data);
      }
    },

    // 传值
    async sendMessageToIframe() {
      console.log("sendMessageToIframe");
      console.log(this.$refs.AIIFrame, "iframe");
      // const host = window.location.host
      // const targetOrigin = 'http://192.168.0.125:3300/'
      const targetOrigin = process.env.VUE_APP_IFRAME_SRC;
      const sourceChannel = this.aiUserInfoForm.sourceChannel;
      const sourceChannelLogo = this.aiUserInfoForm.sourceChannelLogo;
      const sourceSystem = this.aiUserInfoForm.sourceSystem;
      const sourceSystemId = this.aiUserInfoForm.sourceSystemId;
      const sourceSystemName = this.aiUserInfoForm.sourceSystemName;

      const sourceUserId = this.aiUserInfoForm.sourceUserId;
      const sourceUserName = this.aiUserInfoForm.sourceUserName;
      const platformName = this.aiUserInfoForm.platformName;
      const message = {
        sourceChannel,
        sourceChannelLogo,
        sourceSystem,
        sourceSystemId,
        sourceSystemName,
        sourceUserId,
        sourceUserName,
        platformName
      };
      this.$refs.AIIFrame.contentWindow.postMessage(JSON.stringify(message), targetOrigin); // 'expected-origin' 应与 iframe 的实际来源匹配
    }
  }
};
</script>

<style scoped lang="scss">
/* 遮罩层样式 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999; /* 确保遮罩层在 iframe 下方 */
}

.iframeAi {
  position: fixed;
  width: 70%;
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
}
</style>
